import { useTranslation } from 'react-i18next';

import styles from '@/components/CardPartner/styles.module.css';

interface CardPartnerTutorialsTileProps {
  onClick: () => void;
}

const CardPartnerTutorialsTile = ({ onClick }: CardPartnerTutorialsTileProps) => {
  const { t } = useTranslation();

  return (
    <button type="button" className={styles.tile} onClick={onClick}>
      <span className={styles.tileLabel}>{t('videoTutorials.seeTutorials')}</span>
      <i className={`totem-icon totem-icon-chevron-right ${styles.tileIcon}`} />
    </button>
  );
};

export default CardPartnerTutorialsTile;
